import React from 'react';
import ArrowUp from 'mdi-material-ui/ArrowUp';

import { ButtonLabelEnum } from 'app/shared/enums';
import { NewButton } from 'app/components/NewButton';

import { BackToTopButtonProps } from './BackToTopButton.interface';
import { useStyles } from './BackToTopButton.styles';

export default function BackToTopButton(props: BackToTopButtonProps) {
  const classes = useStyles();

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <NewButton
      suffixIcon={ArrowUp}
      variant={'contained'}
      color={'primary'}
      onClick={handleScrollTop}
      title={ButtonLabelEnum.Up}
      className={classes.root}
    />
  );
}
